import { REGISTER_SUCCESS } from './actionTypes';

export function setRegistrationMessage(show) {
    return { data: show, type: REGISTER_SUCCESS };
}
